import { render, staticRenderFns } from "./EventCart.vue?vue&type=template&id=1fb0b1c9&scoped=true&"
import script from "./EventCart.vue?vue&type=script&lang=js&"
export * from "./EventCart.vue?vue&type=script&lang=js&"
import style0 from "./EventCart.vue?vue&type=style&index=0&id=1fb0b1c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb0b1c9",
  null
  
)

export default component.exports